// extracted by mini-css-extract-plugin
export default {"items":"Style_items__8Gxdt","control_btn":"Style_control_btn__Ob09Z","next":"Style_next__vyjzE","prev":"Style_prev__9+nNa"};